// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropdownItem-module-item > button {
  border: none;
}

.DropdownItem-module-item > button > section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.DropdownItem-module-item > button > svg {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/DropdownItem/DropdownItem.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".item > button {\r\n  border: none;\r\n}\r\n\r\n.item > button > section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  text-align: left;\r\n}\r\n\r\n.item > button > svg {\r\n  flex-shrink: 0;\r\n}"],"sourceRoot":""}]);
// Exports
export var item = `DropdownItem-module-item`;
export default ___CSS_LOADER_EXPORT___;
